<template>
  <div class="scale-question-content">
    <form @submit="submit" v-if="!disableSubmit">
      <div
        class="slide-img-wrapper"
        v-if="$store.state.slide.image"
      >
        <Loading v-if="isLoading" />
        <img
          :src="$store.state.slide.image.large"
          alt
          class="slide-img"
          ref="slide-imgg"
          @load="_imgLoaded"
          v-else
        >
      </div>

      <div
        class="py-3 mb-2"
      >
        <div
          class="progress-bar-time-limit"
          :class="{'mb-0': !$store.state.presentation.presenting
            || $store.state.presentation.presenting
            && !$store.state.slide.hasTimeLimit }"
        >
          <ProgressBarTimer />
        </div>

        <div>
          <div
            v-for="(item, index) in $store.state.slide.SlideOptions"
            :key="index"
            class="mt-4 mb-5 range-limit-choice"
            :class="{'opacity-05': (item.scaleSkip && !$store.state.slide.scale.mustRate) || $store.state.slide.stopSubmission}"
            v-show="isVisibleOption(index)"
          >
            <div class="mt-0 mb-0 horizontal layout center">
              <div class="flex">
                <h3 class="mt-0 mb-0 word-wrap-anywhere">
                  <span v-if="$store.state.slide.SlideOptions.length > 1">{{ index + 1 }}. </span>
                  <span>{{ item.title }}</span>
                </h3>
              </div>
              <div
                class="ml-2 text-right pointer"
                @click="toggleSkip(item.id)"
                v-if="!$store.state.slide.scale.mustRate"
              >
                <button
                  type="button"
                  class="button button-skip"
                  :class="{'button-skip-disabled': $store.state.slide.stopSubmission}"
                >
                  {{ $t('Skip') }}
                </button>
              </div>
            </div>

            <div class="mt-3 mb-3 text-center font-size-90">
              {{ item.scaleValue }}{{ getLabel(item.scaleValue) ? ': ' : '' }}
              <span class="font-weight-bold">{{ getLabel(item.scaleValue) }}</span>
            </div>

            <div class="horizontal layout center">
              <input
                type="range"
                :min="$store.state.slide.scale.lowValue"
                :max="$store.state.slide.scale.highValue"
                v-model="item.scaleValue"
                @input="updateValue"
                :style="scaleStyle(index, item.scaleSkip && !$store.state.slide.scale.mustRate)"
                :disabled="(item.scaleSkip && !$store.state.slide.scale.mustRate) || $store.state.slide.stopSubmission"
              >
            </div>
            <div class="mt-2 horizontal layout center font-size-80">
              <div class="flex">
                {{ $store.state.slide.scale.lowLabel }}
              </div>
              <div class="flex text-right">
                {{ $store.state.slide.scale.highLabel }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="btn-submit"
        id="btn-submit"
        v-if="$store.state.slide.SlideOptions && $store.state.slide.SlideOptions.length"
        :class="{'dark': $store.state.slide.textColour == '#ffffff'}"
      >
        <ui-button
          block
          size="lg"
          type="submit"
          :disabled="submiting || $store.state.slide.stopSubmission || disableSubmit"
        >
          <template v-if="!$store.state.slide.stopSubmission">
            <span>
              {{ $t("submit") }}
              <CountDownTimer />
            </span>
            <i class="fas fa-check" v-if="!submiting" />
            <ui-spinner v-else />
          </template>

          <template v-if="$store.state.slide.stopSubmission">
            <span>{{ $t("submissionClosedButton") }}</span>

            <i class="fa fa-lock" />
          </template>
        </ui-button>
      </div>

      <div
        class="stop-submission"
        v-if="$store.state.slide.stopSubmission"
      >
        {{ $t("stopSubmission") }}
      </div>

      <div v-if="errorText" class="mb-3 text-center text-danger">
        {{ errorText }}
      </div>
    </form>

    <SlideWaiting v-else />
  </div>
</template>

<script>
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default'
import { mapState } from 'vuex'
import Config from '@/config'
import Constant from '@/constant'
import Util from '@/util'
import EvenBus from '@/eventBus'
import Loading from '@/components/Loading'
import storage from '@/services/storage'
import CountDownTimer from '@/components/CountDownTimer'
import ProgressBarTimer from '@/components/ProgressBarTimer'
import SlideWaiting from '@/components/SlideWaiting.vue'

// UI
import UiButton from '@/components/UI/Button'
import UiSpinner from '@/components/UI/Spinner'

export default {
  components: {
    Loading,
    UiButton,
    UiSpinner,
    CountDownTimer,
    ProgressBarTimer,
    SlideWaiting,
  },
  data() {
    return {
      submiting: false,
      errorText: '',
      isLoading: false,
      disableSubmit: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slide,
      audienceId: (state) => state.audienceId,
      presentation: (state) => state.presentation,
    }),
  },
  watch: {
    '$store.state.slide': function () {
      setTimeout(() => {
        if (this.$refs['slide-imgg'] && !this.$refs['slide-imgg'].complete) {
          this.isLoading = true
        }
      }, 1)
    },
    '$store.state.slide.SlideOptions': function () {
      this.setDefaultValue()
    },
    '$store.state.slide.scale': function () {
      if (this.slideActive.scale.mustRate) {
        this.slideActive.SlideOptions.forEach((option) => {
          option.scaleSkip = false
        })
      }
      this.setDefaultValue()
    },
  },
  created() {
    this.setDefaultValue()
  },
  mounted() {
    this._setFloatingSubmitBtn()

    const answeredSlideIds = storage.getValueByPresentation(this.presentation.id, 'answeredSlideIds', [])
    if (answeredSlideIds.includes(this.$store.state.slide.id)) {
      this.disableSubmit = true
    }
  },

  destroyed() {
    if (window.onscroll) {
      window.onscroll = null
    }
  },

  methods: {
    isVisibleOption(index) {
      return index < 8
    },
    setDefaultValue() {
      let changed = false
      this.slideActive.SlideOptions.forEach((o) => {
        if (o.scaleValue == null
          || o.scaleValue < this.slideActive.scale.lowValue
          || o.scaleValue > this.slideActive.scale.highValue) {
          o.scaleValue = this.slideActive.scale.lowValue
          changed = true
        }
      })
      if (changed) {
        this.slideActive.SlideOptions.push()
      }
    },
    toggleSkip(id) {
      this.slideActive.SlideOptions.forEach((o) => {
        if (o.id === id) {
          o.scaleSkip = !o.scaleSkip
        }
      })
      this.updateValue()
    },
    updateValue() {
      this.$store.state.slide.SlideOptions.push()
    },
    getLabel(value) {
      if (String(value) === String(this.$store.state.slide.scale.lowValue)) {
        return this.$store.state.slide.scale.lowLabel
      }
      if (String(value) === String(this.$store.state.slide.scale.highValue)) {
        return this.$store.state.slide.scale.highLabel
      }

      if (this.$store.state.slide.scale.highValue - this.$store.state.slide.scale.lowValue > 10) {
        return ''
      }

      return this.$store.state.slide.scale[
        value - this.$store.state.slide.scale.lowValue - 1
      ]
    },
    scaleStyle(i, skip) {
      return { '--scale-color': skip || this.$store.state.slide.stopSubmission ? '#d4d4d4' : Constant.colors[i], cursor: skip || this.$store.state.slide.stopSubmission ? 'not-allowed' : 'pointer' }
    },
    _setFloatingSubmitBtn() {
      const submitBtn = document.getElementById('btn-submit')
      setTimeout(() => {
        const page = document.documentElement
        if (page.scrollHeight > page.clientHeight) {
          if (submitBtn) {
            submitBtn.classList.add('sticky-btn')
          }
        }
      }, 200)

      window.onscroll = () => {
        const docBody = document.documentElement || document.body.parentNode || document.body
        const hasOffset = window.pageYOffset !== undefined
        const scrollTop = hasOffset ? window.pageYOffset : docBody.scrollTop

        if (!submitBtn) return

        if (scrollTop >= docBody.scrollHeight - docBody.clientHeight) {
          submitBtn.classList.remove('sticky-btn')
        } else {
          submitBtn.classList.add('sticky-btn')
        }
      }
    },
    openImage(img) {
      const pswpElement = document.querySelectorAll('.pswp')[0]

      // build items array
      const items = []
      items.push({
        src: img,
        w: -1,
        h: -1,
        title: '',
      })
      // define options (if needed)
      const options = {
        // optionName: 'option value'
        // for example:
        history: false, // disable photoswipe from modifying history, avoid conflict with back to last slide
        index: 0, // start at first slide
      }

      // Initializes and opens PhotoSwipe
      const gallery = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUIDefault,
        items,
        options,
      )

      // $(".pswp__item").addClass("img-none");

      gallery.listen('imageLoadComplete', (index, item) => {
        if (item.w < 1 || item.h < 1) {
          const img = new Image()
          img.src = item.src
          img.onload = function () {
            item.w = img.width
            item.h = img.height
            gallery.invalidateCurrItems()
            gallery.updateSize(true)
          }
          // setTimeout(() => {
          //   $(".pswp__item").removeClass("img-none");

          // }, 500)
        }
      })

      gallery.listen('close', () => {
        // $(gallery.container).removeClass('pswp--ready');
      })

      gallery.init()
    },

    handleRadioSelect() {
      this.$store.dispatch('updateSlide', this.$store.state.slide)
    },

    async submit(e) {
      e.preventDefault()

      if (this.submiting) return

      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      const scale = {}
      this.$store.state.slide.SlideOptions.forEach((o) => {
        if (!o.scaleSkip) {
          scale[o.id] = o.scaleValue
        }
      })

      this.errorText = ''
      const payload = {
        presentation: this.$store.state.presentation.id,
        slide: this.$store.state.slide.id,
        audience: this.audienceId,
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        slideTimestamp: this.$store.state.slide.slideTimestamp,
        config: {
          timeToAnswer: this.$store.state.slide.timeToAnswer,
          quizTimestamp: this.$store.state.slide.quizTimestamp,
          multipleChoice: this.$store.state.slide.multipleChoice,
          isCorrectGetPoint: this.$store.state.slide.isCorrectGetPoint,
          stopSubmission: this.$store.state.slide.stopSubmission,
          fastAnswerGetMorePoint: this.$store.state.slide
            .fastAnswerGetMorePoint,
          otherCorrectQuiz: this.$store.state.slide.otherCorrectQuiz,
          correctQuizTypeAnswer: this.$store.state.slide.correctQuizTypeAnswer,
          maxPoint: this.$store.state.slide.maxPoint,
          minPoint: this.$store.state.slide.minPoint,
          quizToken: this.$store.state.slide.quizToken,
        },
        type: this.$store.state.slide.type,
        slideType: this.$store.state.slide.slideType,
        scale,
      }

      this.submiting = true

      this.$http.post(Config.api.createAnswer, payload).then(
        () => {
          this.submiting = false

          const presentationId = this.$store.state.presentation.id
          const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
          this.disableSubmit = true
          if (!answeredSlideIds.includes(this.$store.state.slide.id)) {
            answeredSlideIds.push(this.$store.state.slide.id)
            storage.setValueByPresentation(presentationId, 'answeredSlideIds', answeredSlideIds)
          }

          EvenBus.$emit('multiple-choice-voted')
          if (this.$store.state.presentation.audiencePacing) {
            EvenBus.$emit('skipSlide')
          } else {
            EvenBus.$emit('confirmNextSlide')
          }
        },
        (err) => {
          this.submiting = false
          if (err.body && err.errorCode === 411) {
            this.errorText = this.$t('submissionClosedButton')
          } else {
            this.errorText = this.$t('openendedSubmissionFail')
          }
          Util.gaTrackEvent(
            'Multiple Choice Submit',
            'Audience submit fail',
            JSON.stringify(err),
          )
        },
      )
    },

    _imgLoaded() {
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.range-limit-choice {
  position: relative;
  padding: 0 0 20px;

  .number {
    font-weight: bold;
    font-size: 14px;
  }

  input {
    width: 100%;
    margin: 0 4px;
  }

  .value {
    position: absolute;
    top: -16px;
    left: 50%;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    width: 30px;
    height: 30px;
    background-color: $primary-color;
    border-radius: 50%;
    text-align: center;
    line-height: 30px;
    margin-left: -15px;
  }
}

// Slider styling
$track-color: #eceff1 !default;
$thumb-color: var(--scale-color);

$thumb-radius: 18px !default;
$thumb-height: 36px !default;
$thumb-width: 36px !default;
$thumb-shadow-size: 1px !default;
$thumb-shadow-blur: 1px !default;
$thumb-shadow-color: rgba(0, 0, 0, .1) !default;
$thumb-border-width: 2px !default;
$thumb-border-color: #eceff1 !default;

$track-width: 95% !default;
$track-height: 8px !default;
$track-shadow-size: 1px !default;
$track-shadow-blur: 1px !default;
$track-shadow-color: rgba(0, 0, 0, .1) !default;
$track-border-width: 2px !default;
$track-border-color: #cfd8dc !default;

$track-radius: 5px !default;
$contrast: 5% !default;

$ie-bottom-track-color: darken($track-color, $contrast) !default;

@mixin shadow($shadow-size, $shadow-blur, $shadow-color) {
  box-shadow: $shadow-size $shadow-size $shadow-blur $shadow-color,
    0 0 $shadow-size lighten($shadow-color, 5%);
}

@mixin track {
  height: $track-height;
  transition: all .2s ease;
  width: $track-width;
}

@mixin thumb {
  @include shadow($thumb-shadow-size, $thumb-shadow-blur, $thumb-shadow-color);
  background: $thumb-color;
  border: $thumb-border-width solid $thumb-border-color;
  border-radius: $thumb-radius;
  box-sizing: border-box;
  height: $thumb-height;
  width: $thumb-width;
}

[type='range'] {
  -webkit-appearance: none;
  background: transparent;
  margin: calc($thumb-height / 2) 0;
  width: $track-width;

  &::-moz-focus-outer {
    border: 0;
  }

  &:focus {
    outline: 0;

    &::-webkit-slider-runnable-track {
      background: lighten($track-color, $contrast);
    }

    &::-ms-fill-lower {
      background: $track-color;
    }

    &::-ms-fill-upper {
      background: lighten($track-color, $contrast);
    }
  }

  &::-webkit-slider-runnable-track {
    @include track;
    @include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
    background: $track-color;
    border-radius: $track-radius;

    -webkit-box-shadow:inset 0px 0px 0px $track-border-width $track-border-color;
    box-shadow:inset 0px 0px 0px $track-border-width $track-border-color;
  }

  &::-webkit-slider-thumb {
    @include thumb;
    -webkit-appearance: none;
    margin-top: calc(($track-border-width * -2 + $track-height) / 2 - $thumb-height / 2);
  }

  &::-moz-range-track {
    @include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
    @include track;
    background: $track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: $track-radius;
    height: calc($track-height / 2);
  }

  &::-moz-range-thumb {
    @include thumb;
  }

  &::-ms-track {
    @include track;
    background: transparent;
    border-color: transparent;
    border-width: calc($thumb-height / 2) 0;
    color: transparent;
  }

  &::-ms-fill-lower {
    @include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
    background: $ie-bottom-track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: ($track-radius * 2);
  }

  &::-ms-fill-upper {
    @include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
    background: $track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: ($track-radius * 2);
  }

  &::-ms-thumb {
    @include thumb;
    margin-top: calc($track-height / 4);
  }
}

.slide-img-wrapper {
  width: auto;
  margin: 0 auto;
  overflow: hidden;
  padding-bottom: 0.83em;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 15px;

  .slide-img {
    margin-bottom: 16px;
  }

  & ::v-deep {
    .spinner {
      width: 120px;
      margin: 0 auto;
    }
    .spinner > div {
      width: 20px;
      height: 20px;
      margin: 0 8px;
    }
  }
}

.btn-submit {
  margin-bottom: 16px;
}
</style>
